import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {FileSystemsActions} from '../store';
import {FileSystemsSelectors} from '../store/selectors';

@Injectable()
export class FileSystemsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadFileSystemsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadFileSystemsDone() {

    return this.store.pipe(
      select(FileSystemsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(FileSystemsActions.ReadFileSystems());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
